import { InfoIcon } from '@mm/icons';
import classnames from 'classnames';
import React from 'react';
import { useSelector } from 'react-redux';
import { Link, Redirect, Route, Switch } from 'react-router-dom';
import useRouter from 'use-react-router';
import { activeChatbotSelector } from '@mm/state/selectors/viewSelectors';
import { Heading } from '@mm/components';
import { SettingsSectionDefinition } from '../sectionConstants';
import './Templates.scss';
import { TEMPLATES_SECTIONS } from './templatesSections';

export const Templates = () => {
  const chatbot = useSelector(activeChatbotSelector);

  const { location } = useRouter();
  const { pathname } = location;

  const getIsActiveMenuItem = (
    pathname: string,
    section: SettingsSectionDefinition,
  ) => {
    return pathname.indexOf(section.path(chatbot.id)) > -1;
  };

  return (
    <div className="templates-settings">
      <div className="templates__content-header-container">
        <Heading
          size={3}
          text="Templates Settings"
          className="templates__content-heading"
        />
        <div className="templates__content-header-info">
          <InfoIcon />
          <p className="templates__field-container-info-text">
            Build interactive chatbots that generate and qualify leads with
            widgets and no coding. Conversational chatbots are helpful,
            interactive, and always-mobile-friendly content experiences.
          </p>
        </div>
      </div>
      <div className="templates__content-topbar">
        {TEMPLATES_SECTIONS.map(section => {
          const isActive = getIsActiveMenuItem(pathname, section);
          return (
            <Link
              key={section.id}
              to={section.path(chatbot.id)}
              className={classnames('templates__content-topbar-link', {
                'templates__content-topbar-link-active': isActive,
              })}
            >
              {section.name}
            </Link>
          );
        })}
      </div>
      <Switch>
        {TEMPLATES_SECTIONS.map(section => (
          <Route
            key={section.id}
            exact
            path={section.path(chatbot.id)}
            component={section.component}
          />
        ))}
        <Redirect to={TEMPLATES_SECTIONS[0].path(chatbot.id)} />
      </Switch>
    </div>
  );
};
